<template>
  <v-row>
    <v-col>
      <v-card class="elevation-2 mx-2 mt-12">
        <v-card-title>
          <v-layout>
            <v-flex xs12>
              <v-card
                dark
                raised
                class="elevation-5 px-3 py-4 mt-n12 subtitle-1 font-weight-light"
                color="secondary"
                >{{ this.title }}</v-card
              >
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-layout>
            <v-flex xs12 class="text-center">
              <p
                class="font-weight-light title"
                v-if="this.managerInfo.Manager"
              >
                {{ this.managerInfo.Manager }}
              </p>

              <v-list dense>
                <v-list-item v-if="this.managerInfo.ManagerPhone">
                  <v-list-item-icon>
                    <a
                      class="text-no-decoration"
                      :href="'tel://' + this.managerInfo.ManagerPhone"
                      :aria-label="this.managerInfo.ManagerPhone"
                    >
                      <v-icon color="secondary">{{ icons.phone }}</v-icon>
                    </a>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <a
                        class="text-no-decoration text-space"
                        :href="'tel://' + this.managerInfo.ManagerPhone"
                        >{{ this.managerInfo.ManagerPhone }}</a
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item v-if="this.managerInfo.ManagerEmail">
                  <v-list-item-icon>
                    <a
                      class="text-no-decoration"
                      :href="'mailto:' + this.managerInfo.ManagerEmail"
                    >
                      <v-icon color="secondary">{{ icons.mail }}</v-icon>
                    </a>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <a
                        class="text-no-decoration"
                        :href="'mailto:' + this.managerInfo.ManagerEmail"
                        >{{ this.managerInfo.ManagerEmail }}</a
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item v-if="this.managerInfo.ManagerSkype">
                  <v-list-item-icon>
                    <a
                      class="text-no-decoration"
                      :href="'skype:' + this.managerInfo.ManagerSkype + '?call'"
                    >
                      <v-icon color="secondary">{{ icons.skype }}</v-icon>
                    </a>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <a
                        class="text-no-decoration"
                        :href="
                          'skype:' + this.managerInfo.ManagerSkype + '?call'
                        "
                        >{{ this.managerInfo.ManagerSkype }}</a
                      >
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <a
                      class="text-no-decoration"
                      :href="'skype:' + this.managerInfo.ManagerSkype + '?call'"
                    >
                      <v-icon color="secondary">{{ icons.chat }}</v-icon>
                    </a>
                  </v-list-item-icon>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item v-if="isServiceManager">
                  <v-list-item-icon>
                    <v-btn fab x-small color="red" @click.stop="onShowDialog">
                      <v-icon color="white">{{ icons.info }}</v-icon>
                    </v-btn>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <a
                        class="text-no-decoration"
                        target="_blank"
                        href="/manuals/pretenzii.docx"
                        >Скачать форму претензии</a
                      >
                      <br />
                      <a
                        class="text-no-decoration"
                        target="_blank"
                        href="/manuals/pretenzii.doc"
                      >
                        (недостача, излишки, пересортица,браки)
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog persistent v-model="dialogService" max-width="500px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <span class="headline">Информация</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="onCloseDialog">
              <v-icon>{{ icons.close }}</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mb-0 pb-0">
          <h2 class="my-3">
            ПРИЕМ ПРЕТЕНЗИЙ ПО КОЛИЧЕСТВУ И КАЧЕСТВУ ТОВАРА И ПО ДОСТАВКЕ
          </h2>

          <p>
            Уважаемые клиенты, в компании Интерфармакс для Вас работает
            клиентская служба. По всем возникающим вопросам при поставке товара
            (недостача, излишки, пересортица,браки) Вы можете связаться с нами
            по телефону или написать на наш электронный адрес заполнив "Форму
            претензии".
          </p>

          <p>Контакты клиентской службы:</p>
          <p>+375 17 543-00-69</p>
          <p>+375 44 729-70-99</p>
          <p>Электронный адрес: pretenzii@interfarmax.by</p>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" sm="6" offset-sm="1"> </v-col>
            <v-col cols="6" sm="2"> </v-col>
            <v-col cols="6" sm="2">
              <v-btn dark color="primary" @click="onCloseDialog">Закрыть</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  props: {
    managerInfo: Object,
    icon: String,
    title: String,
    isServiceManager: Boolean,
  },
  computed: {},
  methods: {
    onShowDialog: function () {
      this.dialogService = true;
    },
    onCloseDialog: function () {
      this.dialogService = false;
    },
  },
  data: () => ({
    dialogService: false,
    icons: {
      chat: Icon.chat,
      mail: Icon.mail,
      phone: Icon.phone,
      skype: Icon.skype,
      close: Icon.close,
      info: Icon.info,
    },
  }),
  mounted: function () {},
};
</script>
